import React, { Fragment } from 'react';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import ProjectSection from '../../components/ProjectSection/ProjectSection';

import MapSection from '../../components/MapSection/MapSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'

import Project1 from '../../images/Trademark-Transport.png'
import Project2 from '../../images/Trademark-Transport-1.png'
import Project3 from '../../images/Trademark-Transport-Projects-2.png'
import Footer from '../../components/footer/Footer';
import SectionTitle from '../../components/SectionTitle/SectionTitle';


const ProjectPage = (props) => {
    const { SectionTitleShow = true } = props
    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <section className={`wpo-breadcumb-area`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={'Project'} />
            </section>

            <section className='project-main section-padding'>
                <div className='container'>
                    <div className='row align-items-center fc-gray'>
                        {SectionTitleShow && (
                            <div className="col-lg-8 col-12 text-start">
                                <SectionTitle subtitle={'Reliable Supply Chain Solutions'} title={'We provide the best warehousing and logistics services nowadays'} />
                            </div>
                        )}
                        <div className='col-12 my-5'>
                            <ul className="list-unstyled mt-3 fs-6">
                                <li className='mb-3 position-relative ps-4'><i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                    OFL has been involved with in the supply chain of many of the major construction projects of the last several years across our nation.</li>
                                <li className='mb-3 position-relative ps-4'><i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                    We deal with suppliers from overseas, unpack the supplies at our warehouse, using our own in-house customs brokers.</li>
                                <li className='mb-3 position-relative ps-4'><i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                    Once the freight arrives in the country we deliver to our own warehouses, unpack the freight and prepare for delivery when you require it. Your own program logistics requirements are dealt with under one banner.</li>
                                <li className='mb-3 position-relative ps-4'><i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                    OFL owns all its assets and technology, this provides the confidence for our clients with full control and transparency throughout the duration of the project.</li>
                            </ul>
                        </div>

                    </div>

                    <div className='row'>
                        <div className='col-lg-4 col-sm-6'>
                            <div className='card p-3 project_card h-100'>
                                <div className='text-center mb-4'>
                                    <img src={Project1} alt='' height={150} />
                                </div>
                                <h4>Recent Lendlease Projects</h4>
                                <ul className="list-unstyled mt-3 fs-6">
                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Crown Casino, Barangaroo
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Crown Resort, Barangaroo
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -60 Martin Place, Sydney
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Barangaroo Towors (1, 2, 3), Sydnoy
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        - 130 Lonsdale, Melbourne
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6'>
                            <div className='card p-3 project_card h-100'>
                                <div className='text-center mb-4'>
                                    <img src={Project2} alt='' height={150} />
                                </div>
                                <h4>Recent Lendlease Projects</h4>
                                <ul className="list-unstyled mt-3 fs-6">
                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -105 Phillip St, Parramatta
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -130 Hyde Park, Sydney
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -3 Parramatta Square, Parramatta
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -4 Rarramatta Squaro. Rarramatta
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -6 Parramatta Square, Parramatta
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6'>
                            <div className='card p-3 project_card h-100'>
                                <div className='text-center mb-4'>
                                    <img src={Project3} alt='' height={150} />
                                </div>
                                <h4>Richard Crookes Construction</h4>
                                <ul className="list-unstyled mt-3 fs-6">
                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Icon Projects
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Park One, Macqaurie Park
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Lee1University of Sydney
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -309 kont st, Sydne
                                    </li>

                                    <li className='mb-3 position-relative ps-4'>
                                        <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                        -Epworth Hospital, Melbourne
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ProjectSection hclass={'wpo-project-section section-padding'} SectionTitleShow={true} projectBtn={true} />
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectPage;
